import React from 'react';
import classes from '../ExpandedPipelines.module.scss';
import Typography from 'new/elements/Typography';
import { Stack } from 'new/elements/Stack';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import FlowTypeIcon from 'js/components/pipelines/cards/FlowTypeIcon';
import { isCapsuleCluster } from 'js/lib/PipelineUtils';
import { CapsuleClusterChip } from 'new/modules/settings/capsules/components/CapsuleClusterChip/CapsuleClusterChip';
import classnames from 'classnames';
import { Tooltip } from '@mui/material';
import { isEmpty } from 'lodash';

interface ListItemFlowProps {
  flow: any;
  selected: boolean;
  selectedFlow: number;
  onClick: (flow: any) => void;
}

export const ListItemFlow = (props: ListItemFlowProps) => {
  const { flow, onClick, selected, selectedFlow } = props;

  const onClickItem = (e) => {
    e.stopPropagation();
    onClick(flow);
  };

  return (
    <Stack>
      <div
        onClick={onClickItem}
        className={classnames(classes.listItemFlowContainer, {
          [classes.listItemFlowContainer_selected]: selected,
        })}
      >
        <Tooltip placement="top-start" title={flow.name}>
          <Typography className={classes.flowName} variant="bodySmall">
            {flow.name}
          </Typography>
        </Tooltip>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <ChipWithCopy tooltipTitle="Copy Flow ID" toCopy={flow.flow_node_id}>
            ID {flow.flow_node_id}
          </ChipWithCopy>
          <FlowTypeIcon className={classes.flowTypeContainer} data={flow} />
          {isCapsuleCluster(flow) && <CapsuleClusterChip name={flow.cluster.name} />}
        </Stack>
      </div>
    </Stack>
  );
};
